module.exports = __webpack_public_path__ + "39946d3f4d8f9bc5eb94dff5871d61c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meredicte/riesgo.png
// module id = 333
// module chunks = 1